// extracted by mini-css-extract-plugin
export default {"FacetHelp":"xs_a bhl_jh bhl_sy","FacetHelp__paragraph":"xs_b bhl_vr bhl_xe","FacetHelp__youtube":"xs_c"};